<template>
    <div class="columns is-vcentered is-mobile my-0 pb-0">
        <div v-if="safe_options.show_title" class="column is-narrow"><strong>{{ title }}</strong></div>
        <template v-if="safe_options.show_flow">
            <div class="column is-narrow px-1">{{ current_value }}</div>
            <template v-if="current_value != new_value ">
                <div class="column is-narrow px-1 icon-col">
                    <b-icon icon="long-arrow-alt-right"></b-icon>
                </div>
                <div class="column is-narrow pl-1 pr-0">{{ new_value }}</div>
                <div v-if="isNumeric(current_value)" class="column is-narrow px-0 icon-col">
                    <b-icon v-if="new_value > current_value" icon="caret-up" type="is-success"></b-icon>
                    <b-icon v-else-if="new_value < current_value" icon="caret-down" type="is-danger"></b-icon>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="column is-narrow px-1">{{ new_value || current_value  }}</div>
            <b-icon v-if="new_value != current_value" icon="caret-up" type="is-success"></b-icon>
        </template>
    </div>  
</template>

<script>
export default {
    props: ['field','current_value','new_value','options'],
    computed: {
        title() { return this.field.replace('_',' ').capitalise() },
        safe_options() {return { show_title: true, show_flow: true, ...this.options} }
    },
    methods: {
        isNumeric(n) {
           return !isNaN(parseFloat(n)) && isFinite(n);
        }
    }
}
</script>

<style lang="scss" scoped>
    .icon-col {
        height:24px; padding-top:0; padding-bottom:0;
    }
    .column { 
        padding-top:0; padding-bottom:0;
    }
</style>    